export default {
    "loading": 'Loading...',
    "language.name": "English",
    "demo.msg": "This is a language demo",
    "product.reset": "Reset",
    "product.search": "Search",
    "login.txt001": "Sign in",
    "login.txt002": "Forgot password",
    "login.txt003": "Sign in",
    "login.txt004": "Accept to the",
    "login.txt005": "Privacy Notice",
    "login.txt006": "About Us",
    "login.txt007": "CIIC Payroll & Tax TechService Co., Ltd",
    "login.txt008": "Hotline",
    "login.txt009": "Scan to contact us",
    "login.txt010": "Scan to follow us",
    "login.txt011": "account",
    "login.txt011-2": "mobile number",
    "login.txt012": "password",
    "login.txt013": "verification code",
    "login.txt013-2": "SMS verification code",
    "login.txt014": "Check the button for accept to the Privacy Notice",
    "login.txt015": "Login success",
    "login.txt016": "Please enter your account",
    "login.txt017": "Please enter your password",
    "login.txt018": "Please enter verification code",
    "login.txt019": "Verification code can be up to 4 digits long",
    "login.txt020": "Please enter the SMS verification code",
    "login.txt021": "Please enter your mobile number",
    "login.txt022": "Please enter a valid mobile number",
    "login.txt023": "Verification code sent",
    "login.txt024": "Failed to send the code, please try again later",
    "login.txt025": "Send",
    "login.txt026": "SMS code must be 6 digits",
    "login.txt027": "SMS login",
    "login.txt028": "",
    "login.txt029": "",
    "homepage.txt001": "Role",
    "homepage.txt002": "Dept",
    "homepage.txt003": "Quick Access",
    "homepage.txt004": "Policy Notice",
    "homepage.txt005": "Expenses Distribution",
    "homepage.txt006": "Tendency Analysis",
    "homepage.txt007": "Year",
    "homepage.txt008": "Cost Statistics by types,(unit:CNY)",
    "homepage.txt009": "Cost",
    "homepage.txt010": "Proportion",
    "homepage.txt011": "Cost Statistics by month,(unit:CNY)",
    "homepage.txt012": "My Tasks",
    "homepage.txt013": "Close",
    "homepage.txt014": "More",
    "homepage.txt015": "Approve",
    "homepage.txt016": "You are about to log out. Do you want to continue?",
    "homepage.txt017": "Warning",
    "homepage.txt018": "Ok",
    "homepage.txt019": "Cancel",
    "homepage.txt020": "The date has been changed to ",
    "homepage.txt021": "The customer has been changed to ",
    "homepage.txt022": "Confirm file deletion?",
    "homepage.txt023": "Delete Success!",
    "homepage.txt024": "An error occurred while processing your request.",
    "homepage.txt025": "Verification Completed",
    "homepage.txt026": "but exceptions were found",
    "homepage.txt027": "Please select at least one row",
    "homepage.txt028": "Success",
    "homepage.txt029": "Loading",
    "homepage.txt030": "Yes",
    "homepage.txt031": "No",
    "homepage.txt032": "Operation Guide",
    "homepage.txt033": "",
    "homepage.txt034": "",
    "homepage.txt035": "",
    "homepage.txt036": "",
    "homepage.txt037": "",
    "homepage.txt038": "",
    "homepage.txt039": "",
    "homepage.txt040": "",
    "homepage.shortCut001": "Payment",
    "homepage.shortCut002": "Contract",
    "homepage.shortCut003": "Invoice",
    "homepage.shortCut004": "Travel",
    "homepage.shortCut005": "Cash Advance",
    "homepage.shortCut006": "Seal",
    "homepage.shortCut007": "",
    "homepage.shortCut008": "",
    "homepage.shortCut009": "",
    "homepage.shortCut010": "",
    "homepage.module001": "Payment",
    "homepage.module002": "Pending",
    "homepage.module003": "Finance",
    "homepage.module004": "Rejected",
    "homepage.module005": "Draft",
    "homepage.module006": "Supplier contract",
    "homepage.module007": "Inactive",
    "homepage.module008": "Withdrawn",
    "homepage.module009": "Invoice",
    "homepage.module010": "Pending",
    "homepage.module011": "Submitted",
    "homepage.module012": "Issuing",
    "homepage.module013": "Travel",
    "homepage.module014": "Pending",
    "homepage.module015": "Cash advance",
    "homepage.module016": "Seal",
    "homepage.module017": "Sealing",
    "homepage.module018": "Daily Reimb",
    "homepage.module019": "Travel Reimb",
    "homepage.module020": "Supplier Pay",
    "homepage.module021": "Cash advance",
    "homepage.module022": "Invoice",
    "homepage.module023": "Sup contract",
    "homepage.module024": "Cus contract",
    "homepage.module025": "Travel",
    "homepage.module026": "Seal",
    "homepage.module027": "Inventory",
    "homepage.module028": "Cashier Review",
    "homepage.module029": "Cashier Pay",
    "homepage.module030": "Finance Review",
    "homepage.module031": "Issue Invoice",
    "homepage.module032": "",
    "homepage.module033": "",
    "homepage.module034": "",
    "homepage.module035": "",
    "homepage.module036": "",
    "homepage.module037": "",
    "homepage.module038": "",
    "homepage.module039": "",
    "homepage.module040": "",
    "menu.txt001": "Overview",
    "menu.cost001": "Cost Manage",
    "menu.cost002": "Payment",
    "menu.cost003": "Invoice Folder",
    "menu.cost004": "Payment application",
    "menu.cost005": "Travel application",
    "menu.cost006": "Cash Advance",
    "menu.cost007": "Cash Advance",
    "menu.cost008": "Repayment",
    "menu.cost009": "Cash Advance/Repayment Ledger",
    "menu.cost010": "Vendor",
    "menu.cost011": "Vendor management",
    "menu.cost012": "Suppplyer Contract",
    "menu.cost013": "End Suppplyer Contract",
    "menu.cost014": "Cashier Pay",
    "menu.cost015": "Pending approval",
    "menu.cost016": "Pending approval payment",
    "menu.cost017": "Other",
    "menu.cost018": "Approval records",
    "menu.cost019": "Approval records payment",
    "menu.cost020": "Other",
    "menu.cost021": "Finance",
    "menu.cost022": "Finance query",
    "menu.cost023": "Cashier check",
    "menu.cost024": "Finance verification",
    "menu.cost025": "Verification records",
    "menu.cost026": "G/L management",
    "menu.cost027": "Receipt",
    "menu.cost028": "ReceiptList",
    "menu.cost029": "UploadReceipt",
    "menu.other001": "Others",
    "menu.other002": "Collection",
    "menu.other003": "Bank Copy",
    "menu.other004": "Invoice application",
    "menu.other005": "Customer management",
    "menu.other006": "Customer Contract",
    "menu.other007": "End Customer Contract",
    "menu.other008": "Payroll",
    "menu.other009": "Seal approval",
    "menu.other010": "",
    "menu.other011": "Others query",
    "menu.other012": "Exchange rate inquiry",
    "menu.other013": "Query cost details",
    "menu.other014": "Cash Advance/Repayment Records",
    "menu.other015": "Query classify details",
    "menu.other016": "Preferential Policy",
    "menu.other017": "",
    "menu.other018": "",
    "menu.other019": "",
    "menu.other020": "",
    "menu.inventory001": "Inventory",
    "menu.inventory002": "Storage detail",
    "menu.inventory003": "Batch List",
    "menu.inventory004": "Batch application",
    "menu.inventory005": "Batch report",
    "menu.report001": "Report",
    "menu.report002": "Financial Statement Accounting",
    "menu.report003": "Report Detail",
    "menu.report004": "Assets Accounting",
    "menu.report005": "Report Fee",
    "menu.report006": "Visual view",
    "menu.report007": "Contract balance report",
    "menu.report008": "Tax inquiry",
    "menu.report009": "Journal",
    "menu.report010": "Invoice inquiry",
    "menu.sys001": "System",
    "menu.sys002": "Basic information",
    "menu.sys003": "Department management",
    "menu.sys004": "Staff management",
    "menu.sys005": "Account management",
    "menu.sys006": "Vendor management",
    "menu.sys007": "Project management",
    "menu.sys008": "Project expense management",
    "menu.sys009": "Receipt type management",
    "menu.sys010": "Project expense management",
    "menu.sys011": "Seal management",
    "menu.sys012": "Item type management",
    "menu.sys013": "Item management",
    "menu.sys014": "Init storage",
    "menu.sys015": "Authority management/Privilege",
    "menu.sys016": "Role management",
    "menu.sys017": "User management",
    "menu.sys018": "User authorization",
    "menu.sys019": "User powerTransfer",
    "menu.sys020": "Budget Management",
    "menu.sys021": "Process setting",
    "menu.sys022": "Payment Process Travel application process setup",
    "menu.sys023": "Cash Advance Process setup",
    "menu.sys024": "Travel application process setup",
    "menu.sys025": "Contract approval process setup",
    "menu.sys026": "Invoice approval process setup",
    "menu.sys027": "Seal approval process setup",
    "menu.sys028": "Inventory approval process setup",
    "menu.sys029": "Contract setting",
    "menu.sys030": "Contract Template",
    "menu.sys031": "Contract NO",
    "menu.sys032": "User-defined management",
    "menu.sys033": "EmailTemplate management",
    "menu.sys034": "Category name set",
    "menu.sys035": "Budget category settings",
    "menu.sys036": "Travel address maintenance",
    "menu.sys037": "Reimbursement instructions set",
    "menu.sys038": "Custom function switch",
    "menu.sys039": "Data initialization",
    "menu.sys040": "Project information initialization",
    "menu.sys041": "Basic information initialization",
    "menu.sys042": "Payee account information initialization",
    "menu.sys043": "Reimbursement management tips",
    "menu.sys044": "System Operate Logs",
    "menu.sys045": "",
    "menu.sys046": "",
    "menu.sys047": "",
    "menu.sys048": "",
    "menu.sys049": "",
    "index.txt001": "Password reset",
    "index.txt002": "Logout",
    "cost.invoice001": "AI Invoice Recognition",
    "cost.invoice002": "Create Other Receipt",
    "cost.invoice003": "Delete",
    "cost.invoice004": "Number",
    "cost.invoice005": "Type",
    "cost.invoice006": "Date",
    "cost.invoice007": "Amount",
    "cost.invoice008": "Input Date",
    "cost.invoice009": "Description",
    "cost.invoice010": "Status",
    "cost.invoice011": "Verification",
    "cost.invoice012": "Verifi Description",
    "cost.invoice013": "Operate",
    "cost.invoice014": "View",
    "cost.invoice015": "Edit&Confirm",
    "cost.invoice016": "Verification",
    "cost.invoice017": "Delete",
    "cost.invoice018": "Available",
    "cost.invoice019": "Uncheck",
    "cost.invoice020": "Used",
    "cost.invoice021": "Recognition Results",
    "cost.invoice022": "Error Message",
    "cost.invoice023": "Warning Message ",
    "cost.invoice024": "Invoice Information Maintenance",
    "cost.invoice025": "Invoice Group",
    "cost.invoice026": "Upload Receipt File",
    "cost.invoice027": "Invoice Information",
    "cost.invoice028": "Cost Project",
    "cost.invoice029": "Invoice Code",
    "cost.invoice030": "Invoice Date",
    "cost.invoice031": "Start Date",
    "cost.invoice032": "End Date",
    "cost.invoice033": "Departure",
    "cost.invoice034": "Destination",
    "cost.invoice035": "Currency",
    "cost.invoice036": "Exchange Rate",
    "cost.invoice037": "RMB Amount",
    "cost.invoice038": "Tax-Inclusive Amount",
    "cost.invoice039": "Tax-Exclusive Amount",
    "cost.invoice040": "Tax Amount",
    "cost.invoice041": "Buyer Name",
    "cost.invoice042": "Buyer Tax ID",
    "cost.invoice043": "Remark",
    "cost.invoice044": "Warn Message",
    "cost.invoice045": "Back",
    "cost.invoice046": "Save & Confirm",
    "cost.invoice047": "Invoice Number",
    "cost.invoice048": "Invoice Type",
    "cost.invoice049": "Invoice File",
    "cost.invoice050": "Choose File",
    "cost.invoice051": "Please select an ",
    "cost.invoice052": "Please enter the ",
    "cost.invoice053": "Please upload the file",
    "cost.invoice054": "Please confirm that all required fields have been completed !",
    "cost.invoice055": "No attachments found. Please contact system support !",
    "cost.invoice056": "The invoice still has exceptions",
    "cost.invoice057": "Do you still want to confirm it?",
    "cost.invoice058": "Confirm Success",
    "cost.invoice059": "Do you want to discard the current operation?",
    "cost.invoice060": "Please select an invoice type before uploading attachments !",
    "cost.invoice061": "The imported file is empty. Please select a valid file and try again !",
    "cost.invoice062": "Uploaded file's size must not exceed",
    "cost.invoice063": "Added standard Chinese invoices. Use AI-powered recognition for one-click upload, smart detection, and easier entry.",
    "cost.invoice064": "",
    "cost.invoice065": "",
    "cost.invoice066": "",
    "cost.invoice067": "",
    "cost.invoice068": "",
    "cost.invoice069": "",
    "cost.invoice070": "",
    "cost.cost001": "Payment Application",
    "cost.cost002": "Req Date",
    "cost.cost003": "Type",
    "cost.cost004": "Applicant",
    "cost.cost005": "Payee",
    "cost.cost006": "Pay Amount",
    "cost.cost007": "Amount",
    "cost.cost008": "Reimb Reason",
    "cost.cost009": "Stage ",
    "cost.cost010": "Rejection",
    "cost.cost011": "Withdrawal",
    "cost.cost012": "Suppl",
    "cost.cost013": "View",
    "cost.cost014": "Edit",
    "cost.cost015": "Delete",
    "cost.cost016": "Preview",
    "cost.cost017": "Withdraw",
    "cost.cost018": "Pending",
    "cost.cost019": "Finance",
    "cost.cost020": "Rejected",
    "cost.cost021": "Withdrawed",
    "cost.cost022": "Draft",
    "cost.cost023": "Paid",
    "cost.cost024": "Select Payment Application Type",
    "cost.cost025": "No Payment Application Type found. Please check!",
    "cost.cost026": "Payment Application Information",
    "cost.cost027": "Is contract-related payment?",
    "cost.cost028": "Suppplyer",
    "cost.cost029": "Contract Number",
    "cost.cost030": "Invoice Date",
    "cost.cost031": "Claimant",
    "cost.cost032": "Department",
    "cost.cost033": "Project",
    "cost.cost034": "Payee-Claimant",
    "cost.cost035": "Travel Number",
    "cost.cost036": "Payee-Suppplyer",
    "cost.cost037": "Payment Method",
    "cost.cost038": "Bank Account",
    "cost.cost039": "Maintain Bank Account",
    "cost.cost040": "View",
    "cost.cost041": "Contact",
    "cost.cost042": "Expense Details",
    "cost.cost043": "Choose from Invoice Folder",
    "cost.cost044": "Expense Allocation",
    "cost.cost045": "Upload Files",
    "cost.cost046": "Delete",
    "cost.cost047": "Warn",
    "cost.cost048": "Contract Amount",
    "cost.cost049": "Maximum Limit",
    "cost.cost050": "Amount Paid",
    "cost.cost051": "Payments in Transit (Excl.Current)",
    "cost.cost052": "Number of Payments (Excl.Current)",
    "cost.cost053": "Available Balance",
    "cost.cost054": "Total Reimb",
    "cost.cost055": "Cash Advance Information",
    "cost.cost056": "Offset Amount",
    "cost.cost057": "Total Payment",
    "cost.cost058": "Cancel",
    "cost.cost059": "Save Draft",
    "cost.cost060": "Submit",
    "cost.cost061": "RMB",
    "cost.cost062": "Cash Advance Type",
    "cost.cost063": "Cash Advance Reason",
    "cost.cost064": "Amount",
    "cost.cost065": "Please enter expense details before submission!",
    "cost.cost066": "Columu In Payment Detail",
    "cost.cost067": "Can Not Be Empty！",
    "cost.cost068": "Please enter valid contact details! ",
    "cost.cost069": "The offset amount cannot exceed the advance amount!",
    "cost.cost070": "The offset amount cannot exceed the total Reimb amount!",
    "cost.cost071": "Are you sure you want to delete this row?",
    "cost.cost072": "Upload",
    "cost.cost073": "Select file or scan QR code with WeChat to upload",
    "cost.cost074": "Scan QR code with WeChat",
    "cost.cost075": "Select File",
    "cost.cost076": "Upload File",
    "cost.cost077": "File List",
    "cost.cost078": "Continue",
    "cost.cost079": "Cancel",
    "cost.cost080": "This file type is not supported.",
    "cost.cost081": "Please upload an invoice/receipt before submitting",
    "cost.cost082": "Are you sure you want to submit the document for recognition",
    "cost.cost083": "Empty",
    "cost.cost084": "Expense Allocation Manage",
    "cost.cost085": "Expense Allocation Method",
    "cost.cost086": "Note: 'Allocation Details' overrides 'Project Group' when both are provided.",
    "cost.cost087": "Method",
    "cost.cost088": "Expense Allocation Detail",
    "cost.cost089": "Percentage ",
    "cost.cost090": "Clear Allocation",
    "cost.cost091": "Please set up the allocation details before saving!",
    "cost.cost092": "The allocation amount cannot be zero !",
    "cost.cost093": "The total allocation amount must equal",
    "cost.cost094": "Frequently Used",
    "cost.cost095": "Select Project",
    "cost.cost096": "Department Projects",
    "cost.cost097": "All Projects",
    "cost.cost098": "Please submit medical projects separately.",
    "cost.cost099": "After submission, approval begins. Process below:",
    "cost.cost100": "No matching reimbursement process found. Submission not allowed",
    "cost.cost101": "Budget Situation",
    "cost.cost102": "Select Invoice",
    "cost.cost103": "Add to Payment Detail",
    "cost.cost104": "Create Date",
    "cost.cost105": "Confirm adding selected invoice to expense details",
    "cost.cost106": "Please provide a reason.",
    "cost.cost107": "Withdraw",
    "cost.cost108": "Reason",
    "cost.cost109": "Reject",
    "cost.cost110": "Reason",
    "cost.cost111": "View Process Information",
    "cost.cost112": "Full Approval Process",
    "cost.cost113": "Delete FIles",
    "cost.cost114": "Please upload the approval form attachment before submitting the reimbursement request.",
    "cost.cost115": "",
    "cost.cost116": "",
    "cost.cost117": "",
    "cost.cost118": "",
    "cost.cost119": "",
    "cost.cost120": "",
    "cost.cost121": "",
    "cost.cost122": "",
    "cost.cost123": "",
    "cost.cost124": "",
    "cost.cost125": "",
    "cost.cost126": "",
    "cost.cost127": "",
    "cost.cost128": "",
    "cost.cost129": "",
    "cost.cost130": "",
}
